import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import Helmet from 'react-helmet';
import history from './history';

import Account from './components/account/Account';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import PrivateRoute from './components/common/PrivateRoute';
import { loadUser } from './actions/authActions';

import Navigation from './components/Navigation';
import Footer from './components/Footer';

import Index from './components/Index';
import About from './components/About';
import Documents from './components/documents/Documents';
import Marketing from './components/Marketing';
import Vacancy from './components/Vacancy';
import Posts from './components/Posts';
import Parts from './components/Parts';
import Service from './components/Service';
import Contact from './components/Contact';

import ProductPage from './components/ProductPage';
import Catalog from './components/Catalog';

import store from './store.js';
import './App.sass';

class App extends Component {
  componentDidMount() {
    store.dispatch(loadUser());
  }
  
  render(props) {
    return (
        <Provider store={store}>
            <Router history={history}>
                <Helmet>
                    <link rel="apple-touch-icon" sizes="180x180" href="https://sinomost.kz/media/apple-touch-icon.png" />
                    <link rel="icon" type="image/png" sizes="32x32" href="/img/favicon/favicon-32x32.png" />
                    <link rel="icon" type="image/png" sizes="16x16" href="/img/favicon/favicon-16x16.png" />
                    <link rel="manifest" href="/img/favicon/site.webmanifest" />
                </Helmet>
                <header className="App-header">
                    <Navigation />
                </header>
            <div className="App mt-3">
                <Route path={['/', '/auto', '/tech']} exact component={ Index } />
                <Route path={['/catalog/', '/catalog/:type', '/catalog/:type/:id']} exact component={ Catalog } />
                <Route path={['/product/:type/:id']} exact component={ ProductPage } />

                <Route path='/about' exact component={ About } />
                <Route path='/marketing' exact component={ Marketing } />
                <Route path='/vacancy' exact component={ Vacancy } />
                <Route path='/blog/:id' exact render={(props) => (
                    <Posts/>
                )} />

                <Route path={['/documents', '/documents/:name']} exact component={ Documents } />

                <Route path='/parts' exact component={ Parts } />
                <Route path='/service' exact component={ Service } />

                <Route path='/contact' exact component={ Contact } />


                <Route path={['/account', '/account/settings', '/account/orders', '/account/equipment']} exact component={ Account } />

                <Route path={['/login']} exact component={ LoginForm } />
                <Route path={['/logout']} exact component={ LoginForm } />
                <Route path={['/register']} exact component={ RegisterForm } />
                <footer>
                    <Footer />
                </footer>
            </div>
          </Router>
        </Provider>
    );
  };
}

export default App;
